import {
  Modal,
  Form,
  Button,
  Row,
  notification,
  Col,
  Empty,
  Flex,
  Radio,
  Badge,
  Switch,
  Popover,
} from "antd";
import store from "../../../../../controllers/store";
import "./Import.scss";
import { useState } from "react";
import {
  CloseCircleOutlined,
  DownloadOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import type { RadioChangeEvent, UploadProps } from "antd";
import { message, Upload } from "antd";
import List from "rc-virtual-list";
import { Actor, Capacity } from "../../../..";
import { ImportFromXlsx } from "../../../../../controllers/store/actions/import/import-from-xlsx-actions";
import { useSelector } from "react-redux";
import { getFileValidationResult } from "../../../../../controllers/store/actions/import/get-validation-result-actions";

interface Props {
  loading?: boolean;
  visible: boolean;
  onCancel: () => void;
  onAccept: () => void;
}
const { Dragger } = Upload;
const dispatch = store.dispatch;
const ImportModal = (Props: Props) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const [state, setState] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState("entities");

  const importFromXlstate = useSelector((state: any) => {
    return state.importFromXlsx;
  });

  const importValidationResultstate = useSelector((state: any) => {
    return state.importValidationResult;
  });

  const props: UploadProps = {
    name: "file",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    customRequest: async ({ file, onSuccess, onError }) => {
      try {
        await dispatch(ImportFromXlsx(file as File, selectedEntity));
        if (onSuccess) onSuccess("Ok");
      } catch (e: any) {
        if (onError) {
          onError(e);
        }
      }
    },
    async onChange(info) {
      const { status } = info.file;

      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        await dispatch(getFileValidationResult(importFromXlstate?.upload?.id));
        message.success(`${info.file.name} archivo subido correctamente.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const onChange = (e: RadioChangeEvent) => {
    console.log("radio checked", e.target.value);
    setSelectedEntity(e.target.value);
  };

  return (
    <Modal
      width={1024}
      open={Props.visible}
      title={"Importar catalogos"}
      onOk={() => {
        Props.onAccept();
      }}
      okText={"Importar"}
      cancelText="Cancelar"
      onCancel={() => {
        Props.onCancel();
      }}
    >
      <>
        {contextHolder}
        <Form
          form={form}
          layout="vertical"
          onFinish={async (formData: any) => {}}
          name="import"
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col xs={24} sm={12} md={8} lg={24}>
              <p>1. Selecciona la entidad que deseas importar.</p>
              <Radio.Group onChange={onChange} value={selectedEntity}>
                <Radio value={Actor.Company}>Empresas</Radio>
                <Radio value={Actor.ProminentResearcher}>Investigadores</Radio>
                <Radio value={Actor.ResearchGroup}>Grupos</Radio>
                <Radio value={Actor.University}>Instituciones</Radio>
                <Radio value={Capacity.Projects}>Proyectos</Radio>
                <Radio value={Capacity.Products}>Productos</Radio>
                <Radio value={Actor.Commons}>Otras entidades</Radio>
                <Radio value={Capacity.CommonsCapacity}>
                  Otras Capacidades
                </Radio>
              </Radio.Group>
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <p>2. Descarga la plantilla.</p>
              {selectedEntity === Actor.Company ? (
                <Button
                  type="primary"
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_ENTITIES_TEMPLATE ||
                        "http://api.conectionsantander.com.co/assets/b8984663-54e1-4db4-8444-652cc6ed31ae?download",
                      "_blank"
                    );
                  }}
                  icon={<DownloadOutlined />}
                  size={"small"}
                >
                  Descargar
                </Button>
              ) : null}
              {selectedEntity === Actor.ProminentResearcher ? (
                <Button
                  type="primary"
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_SEARCHERS_TEMPLATE ||
                        "http://api.conectionsantander.com.co/assets/60ab0410-83f3-4fdb-9e98-270b3d7b1796?download",
                      "_blank"
                    );
                  }}
                  icon={<DownloadOutlined />}
                  size={"small"}
                >
                  Descargar
                </Button>
              ) : null}
              {selectedEntity === Actor.University ? (
                <Button
                  type="primary"
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_UNIVERSITIES_TEMPLATE ||
                        "https://api.conectionsantander.com.co/assets/bcc59d83-f07b-4345-b626-43d188859cc1?download",
                      "_blank"
                    );
                  }}
                  icon={<DownloadOutlined />}
                  size={"small"}
                >
                  Descargar
                </Button>
              ) : null}
              {selectedEntity === Actor.ResearchGroup ? (
                <Button
                  type="primary"
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_GROUPS_TEMPLATE ||
                        "http://api.conectionsantander.com.co/assets/102b65b8-fd5c-417e-a3f2-f067dc2641db?download",
                      "_blank"
                    );
                  }}
                  icon={<DownloadOutlined />}
                  size={"small"}
                >
                  Descargar
                </Button>
              ) : null}
              {selectedEntity === Actor.Commons ? (
                <Button
                  type="primary"
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_COMMONS_TEMPLATE ||
                        "http://api.conectionsantander.com.co/assets/fed33785-2740-4846-990d-c593941b891c?download",
                      "_blank"
                    );
                  }}
                  icon={<DownloadOutlined />}
                  size={"small"}
                >
                  Descargar
                </Button>
              ) : null}
              {selectedEntity === Capacity.Projects ? (
                <Button
                  type="primary"
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_PROJECTS_TEMPLATE ||
                        "http://api.conectionsantander.com.co/assets/cdd6faf5-1b7a-4bf0-aab2-6999d534cc5a?download",
                      "_blank"
                    );
                  }}
                  icon={<DownloadOutlined />}
                  size={"small"}
                >
                  Descargar
                </Button>
              ) : null}

              {selectedEntity === Capacity.Products ? (
                <Button
                  type="primary"
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_PRODUCTS_TEMPLATE ||
                        "http://api.conectionsantander.com.co/assets/7fbee68f-92dd-46a9-8d63-d2d8596f550b?download",
                      "_blank"
                    );
                  }}
                  icon={<DownloadOutlined />}
                  size={"small"}
                >
                  Descargar
                </Button>
              ) : null}
              {selectedEntity === Capacity.CommonsCapacity ? (
                <Button
                  type="primary"
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_PRODUCTS_TEMPLATE ||
                        "http://api.conectionsantander.com.co/assets/eae0cd71-b56c-4fdb-abc5-025675b65d4f?download",
                      "_blank"
                    );
                  }}
                  icon={<DownloadOutlined />}
                  size={"small"}
                >
                  Descargar
                </Button>
              ) : null}
            </Col>
            <Col xs={24} sm={12} md={8} lg={24}>
              <p>3. Sube el documento a continuación.</p>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click o arrastra para subir el documento xlsx
                </p>
                <p className="ant-upload-hint">
                  Asegurate de haber descargado y usado la plantilla.
                </p>
              </Dragger>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              {importValidationResultstate?.ImportResult.length > 0 ? (
                <List
                  data={importValidationResultstate?.ImportResult || []}
                  height={200}
                  itemHeight={3}
                  itemKey="id"
                >
                  {(row) => (
                    <p
                      className={row.valid ? "import-success" : "import-error"}
                    >
                      {row.valid ? (
                        <>
                          Fila {`${row.row}`} validada correctamente -{" "}
                          <Badge status={row.valid ? "success" : "error"} />
                        </>
                      ) : (
                        <>
                          Ocurrio un error al validar la Fila {`${row.row} `}
                          <Popover
                            content={() => (
                              <>
                                <ul>
                                  {row?.errors.map((e: any) => {
                                    return (
                                      <li className="import-error-row">
                                        {e.message}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </>
                            )}
                            title="Errores"
                            trigger="focus"
                          >
                            <Button
                              icon={<CloseCircleOutlined />}
                              size="small"
                              danger
                              type="text"
                            >
                              errores
                            </Button>
                          </Popover>
                        </>
                      )}
                    </p>
                  )}
                </List>
              ) : (
                <Flex align="center" justify="center">
                  <Empty description={"Sin resultados."} />
                </Flex>
              )}
            </Col>
          </Row>
          <br />
        </Form>
      </>
    </Modal>
  );
};

export default ImportModal;
